<template>
  <div class="container">
    <h1 class="text-center mt-5 mb-5 pt-5 pb-5 border-top border-bottom">Placeholder</h1>
  </div>
</template>
